// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: '',
  firebase: {
    apiKey: 'AIzaSyAFJQ0bfYINmpFkIVDBeY4wORFuNJyCQiw',
    authDomain: 'admirintegrated.firebaseapp.com',
    databaseURL: 'https://admirintegrated.firebaseio.com',
    projectId: 'admirintegrated',
    storageBucket: 'admirintegrated.appspot.com',
    messagingSenderId: '68718983147',
    appId: '1:68718983147:web:886d420ad05e655e064bae'
  },
  currency: 'EUR'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
